import { Box } from "@mui/material";

export type StatusBadgeTone = "success" | "error" | "warning" | "info" | "default";

interface StatusBadgeProps {
  label: string;
  tone?: StatusBadgeTone;
}

const BADGE_TONE_COLOR: Record<StatusBadgeTone, string> = {
  success: "#2e7d32",
  error: "#d32f2f",
  warning: "#ed6c02",
  info: "#1976d2",
  default: "text.secondary",
};

/** Small pill: tinted background + same-color text. Used for status columns in tables. */
const StatusBadge = ({ label, tone = "default" }: StatusBadgeProps) => (
  <Box
    component="span"
    sx={{
      display: "inline-block",
      px: 1.25,
      py: 0.25,
      borderRadius: "999px",
      border: "1px solid currentColor",
      color: BADGE_TONE_COLOR[tone],
      fontSize: 12,
      fontWeight: 500,
      lineHeight: "20px",
      whiteSpace: "nowrap",
    }}
  >
    {label}
  </Box>
);

export default StatusBadge;
